// @ngInject
const config = ($stateProvider) => {
  $stateProvider.state('tags', {
    parent: 'main',
    url: '/tags',
    views: {
      'main-content': {
        templateUrl: 'main/tags/tags.tpl.html',
      },
    },
    data: { pageTitle: 'Tags' },
  });
};

angular.module('main.tags', []).config(config);
